import EventBase from '../EventClass/EventBase'
import FloatButtonElementData from './FloatButtonElementData'
import { FileReader, FileWriter } from '@/platform'

class FloatButtonData {
    public X: number = 0 // 实际显示的X坐标
    public Y: number = 0 // 实际显示的Y坐标
    public Name: string = ''
    public ElementList: FloatButtonElementData[] = []
    public EventList: EventBase[] = []

    constructor(read?: FileReader) {
        if (read) {
            this.readBin(read)
            return
        }
        this.ElementList = [new FloatButtonElementData(0)]
    }

    readBin(reader: FileReader): void {
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Name = reader.readString()
        this.ElementList = []
        const len = reader.readInt()
        for (let i = 0; i < len; i++) {
            const element = new FloatButtonElementData()
            element.readBin(reader)
            this.ElementList.push(element)
        }
        this.EventList = []
        const eventLen = reader.readInt()
        for (let index = 0; index < eventLen; index++) {
            const event = new EventBase()
            event.readBin(reader)
            this.EventList.push(event)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeString(this.Name)
        writer.writeInt(this.ElementList.length)
        for (let i = 0; i < this.ElementList.length; i++) {
            this.ElementList[i]!.writeBin(writer)
        }
        writer.writeInt(this.EventList.length)
        for (let i = 0; i < this.EventList.length; i++) {
            this.EventList[i]!.writeBin(writer)
        }
    }

    writeGameBin(writer: FileWriter): void {
        writer.writeInt(this.EventList.length)
        for (let i = 0; i < this.EventList.length; i++) {
            this.EventList[i]!.writeGameBin(writer)
        }
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeString(this.Name)
        writer.writeInt(this.ElementList.length)
        for (let i = 0; i < this.ElementList.length; i++) {
            this.ElementList[i]!.writeGameBin(writer)
        }
    }
}
export default FloatButtonData

